import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import getAllowedPaymentOptions from 'state/checkoutPage/paymentOptions/operations/getAllowedPaymentOptions';
import { getAllowedPaymentOptionsLogos } from '../../paymentsLogos';
import { useEffect } from 'react';

function PaymentsOptionsLogos() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllowedPaymentOptions());
  }, [dispatch]);

  const { allowedPaymentOptions } = useSelector((state) => state.checkoutPagePaymentOptions);

  const paymentOptions =
    allowedPaymentOptions &&
    allowedPaymentOptions.map((option) => {
      const providers =
        option.provider === 'NetsEasy'
          ? {
              ...option,
              provider: 'NetsEasy',
              type: ['CreditCard', 'applepay', 'mobilepay', 'klarna'],
            }
          : option;

      return providers;
    });

  const allowedPaymentsLogos = getAllowedPaymentOptionsLogos(paymentOptions);

  return (
    <Root>
      {allowedPaymentsLogos.map((logo) => (
        <Logo key={logo.logoImg} src={logo.logoImg} alt={'logo'} style={logo.style} />
      ))}
    </Root>
  );
}

export default PaymentsOptionsLogos;

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  gap: 6px;
`;

const Logo = styled.img`
  height: 20px;
`;
